import {
    GET_WELCOME,
    GET_MARCA,
    GET_STATE_LOADING,
    GET_STATE_LOADING_MARCA
} from "@/views/home/store/types/types.js";

const getters = {
    [GET_WELCOME]: state => state.welcome,
    [GET_MARCA]: state => state.marca,
    [GET_STATE_LOADING]: state => state.loading,
    [GET_STATE_LOADING_MARCA]: state => state.loadingMarca,
};

export default getters;